// extracted by mini-css-extract-plugin
module.exports = {"noPost":"TimelineSection_noPost__Oy64j","post":"TimelineSection_post__St5uN"};